import React, { useEffect } from "react";
import "./AnimatedNumber.scss";
import DOMPurify from "dompurify";
import { visuallyHidden } from "@mui/utils";
import { useAppLoadingContext } from "../../../Context/AppLoadingContext";
import { AppLoadingContextTypes } from "../../../Context/ContextTypes/AppLoadingContextTypes";
import parse from "html-react-parser";
type AnimatedNumbersTypes = {
  rate: string;
  text: string;
};

export default function AnimatedNumber(props: AnimatedNumbersTypes) {
  // function for animation
  function animatatedCounter() {
    const time = 500;

    // target element, the original span element
    const stat = document.querySelector("#targetValue");

    // pattern used to seperate input number from html into an array of numbers and non numbers. EX $65.3M -> ["$65.3M", "$", "65", ".", "3", "M"]
    const patt = /(\D+)?(\d+)(\D+)?(\d+)?(\D+)?/;
    let result = patt.exec(stat?.textContent!);

    let fresh = true;
    let ticks: any;

    // Remove first full match from result array (we dont need the full match, just the individual match groups).
    result?.shift();

    // Remove undefined values from result array where they didnt have a match in one of the optional regex groups
    let finalResult = result?.filter((res) => res != null);

    // remove the original target element
    while (stat?.firstChild) {
      stat.removeChild(stat.firstChild);
    }

    // loop and replace it with new element, number of span element inserted depends on the number digit
    for (let res of finalResult!) {

      // check for number, if not number create that alone, in this case could be %
      if (isNaN(res as any)) {
        stat?.insertAdjacentHTML("beforeend", `<span>${res}</span>`);
      } else {
        for (let i = 0; i < res.length; i++) {
          stat?.insertAdjacentHTML(
            "beforeend",
            `<span data-value="${res[i]}">
                <span>0</span>
                ${Array(parseInt(res[i]) + 1)
                  .join("0")
                  .split("0")
                  .map(
                    (x, j) => `
                  <span>${j}</span>
                `
                  )
                  .join("")}
              </span>`
          );
        }
      }
    }

    ticks = stat?.querySelectorAll("span[data-value]");

    let activate = () => {
      let top:any = stat?.getBoundingClientRect().top;
      let offset = (window.innerHeight * 3) / 4;

      fresh = false;

      if (top < offset) {
        setInterval(
          () => {
            for (let tick of ticks) {
              let dist = parseInt(tick.getAttribute("data-value")) + 1;
              tick.style.transform = `translateY(-${dist * 100}%)`;
            }
          },
          fresh ? time : 0
        );
        window.removeEventListener("scroll", activate);
      }
    };
    window.addEventListener("scroll", activate);
    activate();
  }
  const { translationsData } = useAppLoadingContext() as AppLoadingContextTypes;
  const DomPurify = (tag: string) => {
    return DOMPurify.sanitize(translationsData[tag]);
  };
  
  // format incoming prop text from i18n tags
  // function formatText() {
  //   let string = props.text.replace('<span style="color:red">{value}</span>', "splitHere");
  //   let splitString = string.split("splitHere");
  //   return splitString;
  // }

  let verbiage =parse(DomPurify("CTFS3-INTEREST-RATE-SECTION-TITLE"))
  let verbiage2 =parse(DomPurify("CTFS3-INTEREST-RATE-SECTION-TITLE-02"))
  useEffect(() => {
    if (props.rate) animatatedCounter();
  }, [props.rate]);

  return (
      <div className="counterContainer">
      {verbiage}
      {" "}
        {/* {formatText()[0]}{" "} */}
        {props.rate &&
        <div className="counter-parent">
          <span style={visuallyHidden}>
            {`${props.rate}% `}
          </span>
          <span className="counter" id="targetValue" aria-hidden={true}>
            {props.rate}%
          </span>
          {" "}
        </div>
        }
      {/* {formatText()[1]} */}
        {verbiage2}
      </div>
 
  );
}
